export default resolution => {
  switch (resolution) {
    case "RealTime":
      return 1;
    case "FiveMinutes":
      return 5;
    case "FifteenMinutes":
      return 15;
    case "ThirtyMinutes":
      return 30;
    case "Hourly":
      return 60;
    case "Daily":
      return 60 * 24;
    default:
      throw new Error("invalid resolution");
  }
};
